import React from "react";

export default function BulkActionBar({ count, total, onSelectAll, onDeselectAll, children }) {
  if (count === 0) return null;

  return (
    <div className="bulk-bar">
      <div className="bulk-bar-left">
        <span className="bulk-bar-count">{count} selected</span>
        {count < total && (
          <button className="bulk-bar-link" onClick={onSelectAll}>Select all {total}</button>
        )}
        <button className="bulk-bar-link" onClick={onDeselectAll}>Deselect</button>
      </div>
      <div className="bulk-bar-actions">
        {children}
      </div>
    </div>
  );
}
